export default __webpack_public_path__ + "static/media/services_rest_place.7f5164b4.svg";